<template>
    <b-navbar toggleable="xl" fixed="top" v-b-scrollspy:nav-scroller class="header-area text-trustami-blue" :class="{'is-sticky': scrolled}">
        <div class="container-fluid container-fluid--cp-150">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="navbar-brand logo-light" to="/">
                <img :src='"../assets/img/logo/logo.svg"' alt="logo">
            </b-navbar-brand>
            <b-navbar-brand class="navbar-brand logo-dark" to="/">
                <img :src='"../assets/img/logo/logo.svg"' alt="logo">
            </b-navbar-brand>
            <b-collapse class="default-nav justify-content-center" is-nav id="nav_collapse">
                <b-navbar-nav class="navbar-nav main-menu text-trustami-blue">
                    <li class="nav-item"><a href="/" class="nav-link router-link-active"><span>{{ $t("navbar.home") }}</span></a></li>
                    <li class="nav-item"><a href="/#about" class="nav-link router-link-active"><span>{{ $t("navbar.about") }}</span></a></li>
                    <li class="nav-item"><a href="/#services" class="nav-link router-link-active"><span>{{ $t("navbar.services") }}</span></a></li>
                    <li class="nav-item"><a href="/#support" class="nav-link router-link-active"><span>{{ $t("navbar.support") }}</span></a></li>
                    <li class="nav-item"><a href="/pricing" class="nav-link router-link-active"><span>{{ $t("navbar.pricing") }}</span></a></li>
                    <li class="nav-item"><a href="/research" class="nav-link router-link-active"><span>{{ $t("navbar.research") }}</span></a></li>
                    <li class="nav-item"><a href="/knowledge" class="nav-link router-link-active"><span>{{ $t("navbar.knowledge") }}</span></a></li>

                    <li class="nav-item mobile-only"><a href="https://app.trustami.ai/login" class="nav-link router-link-active"><span>{{ $t("navbar.login") }}</span></a></li>
                    <li class="nav-item mobile-only"><a href="#" @click="signUp" class="nav-link router-link-active"><span>{{ $t("navbar.signin") }}</span></a></li>
                </b-navbar-nav>
            </b-collapse>
            <b-btn-group class="header-button button--white d-none d-xl-block">
                <LangSwitch />

                <b-link class="btn btn--white sign-up-button-nav space-right" href="https://app.trustami.ai/login">{{ $t("navbar.login") }}</b-link>
                <b-link class="btn btn--white sign-up-button-nav" @click="signUp">{{ $t("navbar.signin") }}</b-link>
            </b-btn-group>
        </div>
    </b-navbar>
</template>

<script>
import LangSwitch from './LangSwitch.vue';

export default {
    name: 'Navbar',
    components: {
        LangSwitch
    },
    data() {
        return {
            load: false,
            limitPosition: 200,
            scrolled: false,
            lastPosition: 500,
        }
    },
    methods: {
        // sticky menu script
        handleScroll() {
            if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
                this.scrolled = true;
                // move up!
            }

            if (this.lastPosition > window.scrollY) {
                this.scrolled = true;
                // move down
            }

            this.lastPosition = window.scrollY;
            this.scrolled = window.scrollY > 50;
        },
        doSignUp() {
            window.location = 'https://app.trustami.ai/register';
        },
        signUp($event) {
            $event.preventDefault();

            if (!window.hasGACookies || window._blocked) {
                this.doSignUp();

                return;
            }

            this.$gtag.conversion({
                'send_to': 'AW-950463112/8krmCOnH94oYEIjVm8UD',
                'event_callback': () => {
                    this.doSignUp();
                }
            });
        }
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    }
}
</script>
